import {BlockEmbed} from './block';
import Aside from './aside';
import AsideContainer from './asideContainer';
import autocomplete from 'autocompleter';

class AsideTours extends BlockEmbed {
  static create(value) {
    console.log('asideTours create');
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode, selected) {
    console.log('asideTours constructor');
    
    super(scroll, domNode);
    this.tours = [];
    this.selected = [];
    this.editMode = false;
    
    if (selected) {
      const selectedAttr = selected.join(',');
      this.selected = selected;
      this.domNode.dataset.selected = selectedAttr;
      this.fetch(selectedAttr);
    }
    
    // туры
    const container = document.createElement('div');
    container.className = 'container-list';
    this.domNode.appendChild(container);
    
    this.grid = document.createElement('ul');
    // this.grid.className = 'list';
    container.appendChild(this.grid);
    
    // контейнер для режима редактирования
    const editContainer = document.createElement('div');
    editContainer.className = 'container-edit';
    this.domNode.appendChild(editContainer);
    
    const editButtons = document.createElement('div');
    editButtons.className = 'buttons';
    editButtons.innerText = 'Управление блоком';
    editContainer.appendChild(editButtons);
  
    this.btnSave = document.createElement('button');
    this.btnSave.setAttribute('type', 'button');
    this.btnSave.innerText = 'Сохранить';
    this.btnSave.addEventListener('click', this.changeMode.bind(this));
    editButtons.appendChild(this.btnSave);
    
    this.btnDestroy = document.createElement('button');
    this.btnDestroy.setAttribute('type', 'button');
    this.btnDestroy.innerText = 'Удалить';
    this.btnDestroy.addEventListener('click', this.remove.bind(this));
    editButtons.appendChild(this.btnDestroy);
    
    this.editGrid = document.createElement('div');
    editContainer.appendChild(this.editGrid);
    
    const onRemove = this.removeSelectedTour.bind(this);
    
    editContainer.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('ql-tour-card-remove')) {
        const slug = e.target.dataset.slug;
        onRemove(slug);
      }
    });
    
    // кнопка переключения между режимами
    const btnMode = document.createElement('button');
    btnMode.setAttribute('type', 'button');
    btnMode.className = 'btn-mode';
    btnMode.innerText = 'Редактировать';
    btnMode.addEventListener('click', this.changeMode.bind(this));
    this.domNode.appendChild(btnMode);
  }
  
  fetch(selected) {
    const body = 'selected='+selected;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', API_DOMAIN + '/api/v0/iceland/tours', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.tours = JSON.parse(xhr.responseText);
        // this.editMode = this.tours.length === 0;
        this.updateEditable();
      }
    };
    xhr.send(body);
  }
  
  changeMode() {
    this.editMode = !this.editMode;
    this.updateEditable();
  }
  
  updateGrid() {
    this.grid.innerHTML = '';
    this.tours.map(tour => {
      this.grid.appendChild(AsideTours.createMarkup(tour));
    });
  }
  
  updateEditGrid() {
    this.editGrid.innerHTML = '';
    
    const searchField = document.createElement('input');
    searchField.classList.add('ql-tour-search');
    searchField.setAttribute('placeholder', 'Поиск туров по названию');
    searchField.autofocus = true;
    
    const onSelect = this.addSelectedTour.bind(this);
  
    autocomplete({
      input: searchField,
      debounceWaitMs: 300,
      minLength: 3,
      fetch: function (text, callback) {
        const body = 'keyword='+searchField.value;
        const xhr = new XMLHttpRequest();
        xhr.open('POST', API_DOMAIN + '/api/v0/iceland/tours', true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = () => {
          if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            callback(data);
          }
        };
        xhr.send(body);
      },
      render: function(tour) {
        const div = document.createElement('div');
        div.textContent = tour.name;
        return div;
      },
      onSelect: onSelect
    });
    
    
    const previewList = document.createElement('ul');
    previewList.classList.add('list');
    
    this.editGrid.appendChild(searchField);
    this.editGrid.appendChild(previewList);

    this.tours.map(tour => {
      previewList.appendChild(AsideTours.createEditMarkup(tour));
    });
    
    if (this.tours.length) {
      this.btnSave.style.display = 'block';
      this.btnDestroy.style.display = 'none';
    } else {
      this.btnSave.style.display = 'none';
      this.btnDestroy.style.display = 'block';
    }
  }
  
  refreshGrid() {
    this.domNode.dataset.selected = this.selected.join(',');
    if (this.editMode) {
      this.updateEditGrid();
    } else {
      this.updateGrid();
    }
  }
  
  updateEditable() {
    this.domNode.classList.toggle('edit', this.editMode);
    this.refreshGrid();
  }
  
  static value(domNode) {
    return domNode.dataset.selected.split(',');
  }
  
  static createMarkup(tour) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="tour-card">
      <figure class="tour-card-media">
          <img class="tour-card-image" src="${tour.image}">
          <span class="tour-card-service" data-service="${tour.service}"></span>
      </figure>
      <div class="tour-card-header">
          <time class="tour-card-time">${tour.duration}</time>
          <p class="tour-card-price">от ${tour.price} €</p>
      </div>
      <p class="h5 tour-card-title">${tour.name}</p>
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  static createEditMarkup(tour) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="ql-tour-card">
      <figure class="ql-tour-card-media">
          <img class="ql-tour-card-image" src="${tour.image}">
          <span class="ql-tour-card-service" data-service="${tour.service}"></span>
      </figure>
      <div>
        <div class="ql-tour-card-header">
            <time class="ql-tour-card-time">${tour.duration}</time>
            <p class="ql-tour-card-price">от ${tour.price} €</p>
        </div>
        <p class="h6 ql-tour-card-title">${tour.name}</p>
      </div>
      <span class="ql-tour-card-remove" title="убрать" data-slug="${tour.slug}">х</span>
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  addSelectedTour(tour) {
    if (this.selected.indexOf(tour.slug) === -1) {
      const oldSelected = this.selected.join(',');
      this.tours.push(tour);
      this.selected.push(tour.slug);
      
      this.updateCache(oldSelected, this.selected.join(','));
    }
    this.refreshGrid();
  }
  
  removeSelectedTour(slug) {
    const oldSelected = this.selected.join(',');
    this.tours = this.tours.filter(tour => tour.slug !== slug );
    this.selected.splice(this.selected.indexOf(slug), 1);
    this.updateCache(oldSelected, this.selected.join(','));
    this.refreshGrid();
  }
  
  updateCache(oldKey, newKey) {
    if (oldKey === newKey) {
      return;
    }
    
    oldKey && AsideContainer._tourCache.remove(oldKey);
    newKey && AsideContainer._tourCache.set(newKey, this);
  }
}

AsideTours.tagName = 'DIV';
AsideTours.blotName = 'asideTours';
AsideTours.className = 'aside-tours';
AsideTours.requiredContainer = Aside;

export default AsideTours;